import { Button, ButtonMode, Modal, ModalWidth } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import { useGlobalModalContext } from '../../../GlobalModal';
import ArticleLimitContent from '../ArticleLimitContent/ArticleLimitContent';
import styles from './ArticleLimitModal.module.scss';
import { Quota } from '../../../../models';

const cx = classNames.bind(styles);

export interface ArticleLimitModalProps {
  onConfirm: () => void;
  quota: Quota;
  isPrivate: boolean;
}

const getHeaderTitle = (isPrivate: boolean) => {
  return isPrivate ? 'Request Access' : 'Subscription Limit';
};

const ArticleLimitModal = ({ onConfirm, quota, isPrivate }: ArticleLimitModalProps): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();

  const renderFooter = () => (
    <>
      <Button dataTestId="article-limit-cancel-button" mode={ButtonMode.SECONDARY} onClick={closeModal}>
        Cancel
      </Button>
      <Button type="submit" onClick={onConfirm} dataTestId="article-limit-continue-button" mode={ButtonMode.PRIMARY}>
        Continue
      </Button>
    </>
  );

  return (
    <Modal
      width={quota.usageExceeded ? ModalWidth.Medium : ModalWidth.Small}
      open
      onClose={closeModal}
      dataTestId="article-limit-modal"
      headerTitle={getHeaderTitle(isPrivate)}
      footer={!quota.usageExceeded ? renderFooter() : undefined}
    >
      <div className={cx('body')}>
        <ArticleLimitContent
          counter={quota.counter}
          limit={quota.limit}
          usageExceeded={quota.usageExceeded}
          onCancel={closeModal}
          onConfirm={onConfirm}
        />
      </div>
    </Modal>
  );
};

export default ArticleLimitModal;
